import request  from "@/utils/request";


//外呼
export function getTcccLoginToken() {
  return request({
    url: "/attendance/outboundCall/getLoginToken",
    method: "get",
    headers: { repeatSubmit: false },
  });
}

//外呼列表
export function getTcccListApi(data,params) {
  return request({
    url: "/system/returnVisit/list",
    method: "post",
    data,
    params,
    headers: { repeatSubmit: false },
  });
}

//今日外呼列表
export function getTcccTodayListApi(data,params) {
  return request({
    url: "/system/returnVisit/todayList",
    method: "post",
    params,
    data,
    headers: { repeatSubmit: false },
  });
}

//加入今日跟进记录
export function tcccTodayAddApi(data) {
  return request({
    url: "/system/returnVisit/add",
    method: "post",
    data,
    headers: { repeatSubmit: false },
  });
}


//移出今日跟进记录
export function tcccTodayRemoveApi(data) {
  return request({
    url: "/system/returnVisit/remove",
    method: "post",
    data,
    headers: { repeatSubmit: false },
  });
}

//同步今日跟进记录
export function tcccSynchronousApi(data) {
  return request({
    url: "/system/returnVisit/synchronous",
    method: "post",
    data,
  });
}


//获取记录id
export function addCallRecordApi(params) {
    return request({
        url: "/attendance/outboundCall/addCallRecord",
        method: "get",
        params
    });
}

//保存Record
export function saveCallRecordApi(params) {
    return request({
        url: "/attendance/outboundCall/saveCallRecord",
        method: "get",
        params
    });
}


//语音转文字 通过跟进id
export function getVisitRecordText(id) {
    return request({
        url: `/report/schoolStudentVisitConfig/getVisitRecordText/${id}`,
        method: "get",
    });
}

//语音转文字 通过跟进 recordId
export function getRecordText(recordId) {
    return request({
        url: `/attendance/outboundCall/getRecordText`,
        method: "get",
        params:{
            recordId
        }
    });
}
//语音url
export function getRecordUrlApi(recordId) {
    return request({
        url: `/attendance/outboundCall/getRecordUrl`,
        method: "get",
        params:{
            recordId
        }
    });
}


//根据电话查用户信息
export function getInfoByPhoneApi(phone) {
    return request({
        url: `/system/returnVisit/getInfoByPhone`,
        method: "get",
        params:{
            phone
        }
    });
}

export function setStudentBySessionid(recordId,stuId) {
    return request({
        url: `/attendance/outboundCall/saveUserId`,
        method: "get",
        params:{
            recordId,
            stuId
        }
    });
}